export default class {
    init() {
        this.scrollStopTimeout = null;

        this.paragraphs = document.querySelectorAll('p, figure');

        let currentParagraph = window.localStorage.getItem('current_paragraph');
        if (currentParagraph && currentParagraph !== '0') {
            let paragraph = this.paragraphs[currentParagraph - 0];

            if (paragraph) {

                window.scrollTo(0, paragraph.offsetTop - 20);
            }
        }

        window.addEventListener('scroll', () => this.checkScroll());
    }

    /**
     * Sets an event to trigger in a few milli seconds that will record when the scroll stopped
     */
    checkScroll() {

        if (this.scrollStopTimeout) {
            clearTimeout(this.scrollStopTimeout);
        }

        this.scrollStopTimeout = setTimeout(() => this.recordPosition(), 50);
    }

    /**
     * Records the scroll position the user is currently at
     */
    recordPosition() {

        let currentParagraph = 0;
        for (let i = 0; i < this.paragraphs.length; i++) {
            let paragraph = this.paragraphs[i];

            if (paragraph.offsetTop < window.scrollY) {
                currentParagraph = i;
            } else {
                break;
            }
        }

        window.localStorage.setItem('current_paragraph', currentParagraph);
    }

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
};
